'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage from "./presto.types$-Two-Factor-Auth-Usage.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthUsage$() {
}
export { $c_Lpresto_types$TwoFactorAuthUsage$ as $c_Lpresto_types$TwoFactorAuthUsage$ };
$p = $c_Lpresto_types$TwoFactorAuthUsage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthUsage$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthUsage$() {
}
export { $h_Lpresto_types$TwoFactorAuthUsage$ as $h_Lpresto_types$TwoFactorAuthUsage$ };
$h_Lpresto_types$TwoFactorAuthUsage$.prototype = $p;
$p.l = (function() {
  return "TwoFactorAuthUsage";
});
$p.z8 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage.$c_Lpresto_types$TwoFactorAuthUsage(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_types$TwoFactorAuthUsage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthUsage$, "presto.types$TwoFactorAuthUsage$", ({
  a2T: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TwoFactorAuthUsage$ as $d_Lpresto_types$TwoFactorAuthUsage$ };
var $n_Lpresto_types$TwoFactorAuthUsage$;
function $m_Lpresto_types$TwoFactorAuthUsage$() {
  if ((!$n_Lpresto_types$TwoFactorAuthUsage$)) {
    $n_Lpresto_types$TwoFactorAuthUsage$ = new $c_Lpresto_types$TwoFactorAuthUsage$();
  }
  return $n_Lpresto_types$TwoFactorAuthUsage$;
}
export { $m_Lpresto_types$TwoFactorAuthUsage$ as $m_Lpresto_types$TwoFactorAuthUsage$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Usage$.js.map
